import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Header({ title, description, structuredData }) {
  const { pathname, search } = useLocation();

  // Build canonical base safely in browser/runtime
  const SITE =
    typeof window !== 'undefined'
      ? `${window.location.protocol}//${window.location.host}`
      : '';

  const pathSegments = pathname.split('/').filter(Boolean);
  const canonical = `${SITE}${pathname}${search || ''}`;

  const breadcrumbItems = pathSegments.map((segment, index) => {
    const path = '/' + pathSegments.slice(0, index + 1).join('/');
    const isLast = index === pathSegments.length - 1;
    const label = decodeURIComponent(segment.replace(/-/g, ' '));

    return (
      <span key={path}>
        {!isLast ? <NavLink to={path}>{label}</NavLink> : <span>{label}</span>}
        {!isLast && <span> &raquo; </span>}
      </span>
    );
  });

  return (
    <>
      <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}

        {/* Canonical */}
        <link rel="canonical" href={canonical} />

        {/* Open Graph / Twitter */}
        <meta property="og:url" content={canonical} />
        <meta property="og:title" content={title} />
        {description && <meta property="og:description" content={description} />}
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* JSON-LD */}
        {structuredData && (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )}
      </Helmet>

      <header className="navbar">
        <div className="logo">
		  <NavLink to="/" end>
			<img src="/assets/logos/logo.png" alt="Real Checks logo" />
		  </NavLink>
		</div>
        <nav className="nav-links">
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>
            Background Checks
          </NavLink>
          <NavLink to="/blogs" className={({ isActive }) => (isActive ? 'active' : '')}>
            Blogs
          </NavLink>
		   <NavLink to="/faq" className={({ isActive }) => (isActive ? 'active' : '')}>
            FAQ
          </NavLink>
          <NavLink to="/pricing" className={({ isActive }) => (isActive ? 'active' : '')}>
            Pricing
          </NavLink>
          <a href="#contact" className="cta-btn">Get a Demo</a>
          <a href="https://fortiteam.real-tech.org/login/" className="login-btn">Login</a>
        </nav>
      </header>

      {/* Breadcrumb is always rendered */}
      <div className="breadcrumb">
        <NavLink to="/">Home</NavLink>
        {pathSegments.length > 0 && <span> &raquo; </span>}
        {breadcrumbItems}
      </div>
    </>
  );
}
